import { useQuery } from '@tanstack/react-query';
import { coinStoreDropApi } from 'apis/sales/coinStoreApis';

/// 썸네일 드롭 리스트
export const useThumbnailDropList = () => {
  const { status, data, error, isFetching } = useQuery(
    ['thumbnailDropList'],
    async () => await coinStoreDropApi.thumbnailImgList(),
    {
      // 데이터 재가공
      select: (data) => {
        // console.log(data);
        const newArr = data.map((v, i) => ({ ...v, key: i }));
        return newArr;
      },
    },
  );
  return { status, data, error, isFetching };
};
